module.exports = __webpack_public_path__ + "static/IMG_4213-22a55ad8f802a50146f667840c584378.jpeg";